// get-scroll-parent.ts
var overflowProps = ["overflow", "overflow-y"];
function getScrollParent(node) {
  if (node === null)
    return null;
  if (node instanceof ShadowRoot)
    return getScrollParent(node.host);
  if (overflowProps.some((prop) => ["auto", "scroll"].includes(getComputedStyle(node).getPropertyValue(prop))))
    return node;
  else
    return getScrollParent(node.parentNode ?? node.getRootNode().host ?? null);
}
export {
  getScrollParent
};
